<ng-container *transloco="let t; read: 'configuration-layers-component'">
  @if (isLoading) {
    <div class="xi-loader-container__inline-overlay">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="configuration-layers__column">
    <div class="configuration-layers__column-header">
      <span> {{ t('layers') }}</span>

      @if (!configuration().removed) {
        <xi-default-button
          text="{{ t('add-layer') }}"
          buttonSize="small"
          [disabled]="isLoading || !canEditLayers"
          [tooltip]="!canEditLayers ? { text: canEditLayersTooltip } : undefined"
          [tooltipDisplayOnDisabled]="true"
          (onClick)="onAddLayerClicked()"
        ></xi-default-button>
      }
    </div>

    <div class="configuration-layers__column-body">
      <div>
        <xi-icon icon="multiple_layer" class="configuration-layers__layer-icon"></xi-icon>

        {{ configuration().name }} ({{ configuration().parents.length }})
      </div>

      <div
        cdkDropList
        (cdkDropListDropped)="onLayerReordered($event)"
        class="configuration-layers__layer-items-wrapper"
      >
        @for (layer of configurationLayers(); track layer; let idx = $index) {
          <div
            (click)="selectLayer(layer)"
            class="configuration-layers__layer-item"
            [class.configuration-layers__layer-item--selected]="selectedLayer === layer"
            cdkDrag
            cdkDragPreviewContainer="parent"
            [cdkDragDisabled]="configuration().removed"
          >
            @if (!configuration().removed) {
              <div cdkDragHandle>
                <xi-icon icon="drag_handle"></xi-icon>
              </div>
            }
            <xi-icon [icon]="layer.layer ? 'multiple_layer' : 'single_layer'"></xi-icon>
            <div class="configuration-layers__layer-item-name">
              <ng-template *appMiddleEllipsize="layer.name"></ng-template>
            </div>
            @if (!configuration().removed) {
              <div>
                <xi-icon-button
                  icon="trash"
                  color="CX"
                  [disabled]="!canEditLayers || !canDeleteLayers"
                  [tooltip]="{ text: deleteLayerTooltip }"
                  (onClick)="onDeleteLayerClicked(idx)"
                >
                </xi-icon-button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="configuration-layers__column">
    <div class="configuration-layers__column-header">
      <div>
        @if (selectedLayer) {
          <div>
            <xi-icon
              [icon]="selectedLayer.layer ? 'multiple_layer' : 'single_layer'"
              class="configuration-layers__column-header-icon"
            ></xi-icon>
            {{ selectedLayer.name }}
          </div>
        }
      </div>

      <div [matTooltip]="editConfigurationTooltip">
        <xi-default-button
          text="{{ t('edit-configuration') }}"
          buttonSize="small"
          [disabled]="!selectedLayer?.isConfiguration"
          (onClick)="onEditConfigurationClicked()"
        ></xi-default-button>
      </div>
    </div>

    @if (!selectedLayer) {
      <div class="configuration-layers__column-body configuration-layers__column-body--empty">
        {{ t('select-a-config') }}
      </div>
    }
    @if (selectedLayer) {
      <div class="configuration-layers__column-body">
        <section>
          <xi-text-area
            label="{{ t('notes') }}"
            [readOnly]="true"
            [resize]="true"
            [value]="selectedLayer.notes || ''"
          ></xi-text-area>
        </section>
        <section>
          <app-tag-editor
            [editable]="false"
            [removable]="false"
            [showCount]="true"
            [configuration]="selectedLayer"
          ></app-tag-editor>
        </section>
        <div class="configuration-layers__config-details-wrapper">
          @for (item of selectedLayerConfigurationItems; track item) {
            <div class="configuration-layers__config-details--item-label">
              {{ item.label }}
            </div>
            <div>{{ item.used }} / {{ item.total | humanizeInt }}</div>
          }
          <div class="configuration-layers__config-details--notes">
            <div class="configuration-layers__config-details--config-label">{{ t('created') }}</div>
            {{ selectedLayer.creation_date | lexDate: 'long' }}
          </div>
          <div class="configuration-layers__config-details--author">
            <div class="configuration-layers__config-details--config-label">{{ t('author') }}</div>
            {{ selectedLayerCreator }}
          </div>
          <div class="configuration-layers__config-details--modified">
            <div class="configuration-layers__config-details--config-label">
              {{ t('modified') }}
            </div>
            {{ selectedLayer.modification_date | lexDate: 'long' }}
          </div>
        </div>
      </div>
    }
  </div>

  @if (hasChangesObs | async) {
    <div @actionButtonsTrigger class="configuration-layers__footer">
      <div>
        <xi-default-button
          buttonSize="large"
          text="{{ t('cancel') }}"
          fill="text"
          [disabled]="!!isSaving"
          (onClick)="cancelEdit()"
        ></xi-default-button>
        <xi-default-button
          buttonSize="large"
          text="{{ t('save') }}"
          [disabled]="!!isSaving"
          (onClick)="saveEdit()"
        ></xi-default-button>
      </div>
    </div>
  }
  @if (showAddLayerDialog) {
    <app-lex-xi-modal
      [isVisible]="showAddLayerDialog"
      maxWidth="500px"
      (close)="onAddLayerDialogClosed(null)"
    >
      <ng-template appXIModalContent>
        @if (showAddLayerDialog) {
          <app-add-configuration-layer-dialog
            [data]="addLayerDialogData"
            (modalClosed)="onAddLayerDialogClosed($event)"
          ></app-add-configuration-layer-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
